import { differenceInHours } from 'date-fns';

import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';
import { INVITE_OFFER_COOKIE } from '@pflegia/util/common/storage/invite-offer-cookies';

import { INVITE_OPEN_SOURCE_EXPIRE_HOURS } from '../application/constants';

export const shouldAutoAcceptInvite = (jobPositionId: string) => {
  if (cookieStorage.getItem(INVITE_OFFER_COOKIE.AutoAccept) !== 'true') return false;

  const storedTime = cookieStorage.getItem(INVITE_OFFER_COOKIE.Time);
  if (!storedTime || cookieStorage.getItem(INVITE_OFFER_COOKIE.JobPositionId) !== jobPositionId) return false;

  return differenceInHours(new Date(), new Date(storedTime)) < INVITE_OPEN_SOURCE_EXPIRE_HOURS;
};

export const clearAutoAcceptInvite = () => cookieStorage.removeItem(INVITE_OFFER_COOKIE.AutoAccept);
